import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-elevate',
  templateUrl: './elevate.component.html',
})
export class ElevateComponent {

  constructor() { }

}
